import { useMutation } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { acceptRentalApplicationShare } from '../api-ts';

export function useAcceptApplicationShare() {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: (params: { listingAlias: string; shareId: string }) => dispatch(acceptRentalApplicationShare(params)),
  });
}
